import { CoreDataPoint } from "../../../Components/Shared/CoreComponents";

export enum AdHocReportVariableWhereSelector {
    Between = 'Between',
    DatePicker = 'DatePicker',
    Dropdown = 'Dropdown',
    Empty = 'Empty',
    Numeric = 'Numeric',
    Text = 'Text'
}

export enum AdHocReportVariableWhereDataFormat {
    DateTime = 'DateTime',
    Number = 'Number',
    String = 'String'
}

export enum AdHocReportVariableWhereOperator {
    Between = 'Between',
    Contains = 'Contains',
    EndsWith = 'EndsWith',
    Equals = 'Equals',
    GreaterThan = 'GreaterThan',
    GreaterThanOrEqual = 'GreaterThanOrEqual',
    IsNotNull = 'IsNotNull',
    IsNull = 'IsNull',
    LessThan = 'LessThan',
    LessThanOrEqual = 'LessThanOrEqual',
    None = 'None',
    NotEquals = 'NotEquals',
    StartsWith = 'StartsWith'
}

export default interface AdHocReportVariableWhereModel {
    title: string;
    inputName: string;
    sourceQuery: string;
    multiSelect: boolean;
    selector: AdHocReportVariableWhereSelector;
    dataFormat: AdHocReportVariableWhereDataFormat;
    required: boolean;
    defaultValue: string;

    coreTypeID: number;
    where: AdHocReportVariableWhereOperator;
    valueLHS: string;
    valueRHS: string;
    variableWhereCoreDataPointModel: CoreDataPoint;
}
